import {connect} from '../../../../redux/utils'
import {getErrors, getOvertimeLevel, getUserManagementDataForUserRates, getUserRates} from './selectors'
import {addNewUserRate, deleteUserRate, updateUserRates} from '../../createPanel/actions'
import {bindActionCreators} from 'redux'
import {isLVTEnabled, isOVREnabled} from '../../../../features/selectors'
import {UserRatesTable} from './UserRatesTable'

export class CreatePanelUserRatesTable extends UserRatesTable {
    constructor({
        updateUserRates = () => {},
        deleteUserRate = () => {},
        addNewUserRate = () => {},
        refreshScrollCb = () => {},
        subscribeSelectorOnScroll = () => {},
    }) {
        super({
            editMode: false,
            updateUserRates,
            deleteUserRate,
            addNewUserRate,
            refreshScrollCb,
            subscribeSelectorOnScroll,
        })
    }
}

export default connect(
    state => ({
        userManagementData: getUserManagementDataForUserRates(state),
        userRates: getUserRates(state),
        overtimeLevel: getOvertimeLevel(state),
        ovrFeatureEnabled: isOVREnabled(state),
        lvtFeatureEnabled: isLVTEnabled(state),
        errors: getErrors(state),
    }),
    dispatch => ({
        updateUserRates: bindActionCreators(updateUserRates, dispatch),
        addNewUserRate: bindActionCreators(addNewUserRate, dispatch),
        deleteUserRate: bindActionCreators(deleteUserRate, dispatch),
    })
)(CreatePanelUserRatesTable)


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/CreatePanelUserRatesTable.js